const specs = {
  standard: {
    operation: 'create',
    create: {
      type: 'bool',
      product: 'flyer_standard',
    },
  },
};


const dependencies = {
  hard: [],
  soft: [],
};


export default { specs, dependencies };
